import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DRAWER } from '@/shared/constants';

export interface DrawerState {
  isDrawerOpen: boolean;
}

const initialState: DrawerState = {
  isDrawerOpen: false
};

const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    toggleDrawer(state) {
      state.isDrawerOpen = !state.isDrawerOpen;
      localStorage.setItem(DRAWER.STATUS_KEY, `${state.isDrawerOpen}`)
    },
    setIsDrawerOpen(state, action: PayloadAction<boolean>) {
      state.isDrawerOpen = action.payload;
    },
  },
});

export const { toggleDrawer, setIsDrawerOpen } = drawerSlice.actions;

export default drawerSlice.reducer;
